<script lang="ts">
	import { page } from '$app/stores';
	import { Search, Tag, Globe, TrendingUp, Flame, Clock, Home, ListVideo } from 'lucide-svelte';

	// Import isActive from another module or define it here
	function isActive(currentPath: string, path: string): boolean {
		return currentPath === path || (path !== '/trails' && currentPath.startsWith(path));
	}
</script>

<div class="text-white overflow-x-hidden w-full -mr-8">
	<!-- Hub navigation -->
	<div class="border-b border-opacity-40 border-surface-3">
		<nav class="overflow-x-auto overflow-y-hidden">
			<div class="flex whitespace-nowrap justify-center">
				<a
					href="/trails"
					class="px-3 py-2 flex items-center gap-1 text-xs {isActive(
						$page.url.pathname,
						'/trails'
					) &&
					!isActive($page.url.pathname, '/trails/org/') &&
					!isActive($page.url.pathname, '/trails/tags/') &&
					!isActive($page.url.pathname, '/trails/origins/')
						? 'text-primary'
						: 'text-gray-500'}"
				>
					<Home size={14} />
					<span>Hub</span>
				</a>

				<a
					href="/trails/search"
					class="px-3 py-2 flex items-center gap-1 text-xs {isActive(
						$page.url.pathname,
						'/trails/search'
					) &&
					!isActive($page.url.pathname, '/trails/org/') &&
					!isActive($page.url.pathname, '/trails/tags/') &&
					!isActive($page.url.pathname, '/trails/origins/')
						? 'text-primary'
						: 'text-gray-500'}"
				>
					<Search size={14} />
					<span>Search</span>
				</a>

				<a
					href="/trails/lists"
					class="px-3 py-2 items-center flex gap-1 text-xs {isActive(
						$page.url.pathname,
						'/trails/lists'
					)
						? 'text-primary'
						: 'text-gray-500'}"
				>
					<ListVideo size={14} />
					<span>Lists</span>
				</a>

				<a
					href="/trails/trending"
					class="px-3 py-2 items-center hidden md:flex gap-1 text-xs {isActive(
						$page.url.pathname,
						'/trails/trending'
					)
						? 'text-primary'
						: 'text-gray-500'}"
				>
					<TrendingUp size={14} />
					<span>Trending</span>
				</a>

				<a
					href="/trails/popular"
					class="px-3 py-2 items-center flex gap-1 text-xs {isActive(
						$page.url.pathname,
						'/trails/popular'
					)
						? 'text-primary'
						: 'text-gray-500'}"
				>
					<Flame size={14} />
					<span>Popular</span>
				</a>

				<a
					href="/trails/recent"
					class="px-3 py-2 items-center hidden md:flex gap-1 text-xs {isActive(
						$page.url.pathname,
						'/trails/recent'
					)
						? 'text-primary'
						: 'text-gray-500'}"
				>
					<Clock size={14} />
					<span>Recent</span>
				</a>

				<a
					href="/trails/tags"
					class="px-3 py-2 items-center hidden md:flex gap-1 text-xs {isActive(
						$page.url.pathname,
						'/trails/tags'
					)
						? 'text-primary'
						: 'text-gray-500'}"
				>
					<Tag size={14} />
					<span>Tags</span>
				</a>

				<a
					href="/trails/origins"
					class="px-3 py-2 flex items-center gap-1 text-xs {isActive(
						$page.url.pathname,
						'/trails/origins'
					)
						? 'text-primary'
						: 'text-gray-500'}"
				>
					<Globe size={14} />
					<span>Websites</span>
				</a>
			</div>
		</nav>
	</div>

	<!-- Main content -->
	<main class="overflow-x-hidden">
		<slot />
	</main>
</div>

<style>
	nav {
		-ms-overflow-style: none;
		scrollbar-width: none;
		max-width: 100%;
		width: 100vw;
		box-sizing: border-box;
	}

	nav::-webkit-scrollbar {
		display: none;
	}
</style>
